import * as React from 'react';

export const Analytics = React.lazy(() => import('./Analytics'));
